import '@/scss/main.scss';
import Vue from 'vue';
import App from '@/App.vue';
import router from '@/router';
import store from '@/store';
import vuetify from '@/plugins/vuetify';
import toast from '@/plugins/toast';
import KpFileInput from '@/components/KpFileInput.vue';
import KpIcon from '@/components/KpIcon.vue';
import IconBtn from '@/components/IconBtn.vue';
import BaseList from '@/components/BaseList.vue';
import BaseRemoteList from '@/components/BaseRemoteList.vue';
import ConfirmDialog from '@/components/ConfirmDialog.vue';
import PromptDialog from '@/components/PromptDialog.vue';
import KpAlert from '@/components/KpAlert.vue';
import KpTooltip from '@/components/KpTooltip.vue';
import SToolbar from '@/components/SublimeToolbar.vue';
import LightToolbar from '@/components/LightToolbar.vue';
import ActionBtn from '@/components/buttons/ActionBtn.vue';
import SecondaryBtn from '@/components/buttons/SecondaryBtn.vue';
import TooltipIcon from '@/components/TooltipIcon.vue';
import PlainBtn from '@/components/buttons/PlainBtn.vue';
import TrueFalseIcon from '@/components/TrueFalseIcon.vue';
import DateTextfield from '@/components/form/DateTextfield.vue';
import TimeTextfield from '@/components/form/TimeTextfield.vue';
import LabelField from '@/components/form/LabelField.vue';
import QueryField from '@/components/form/QueryField.vue';
import AutocompleteDisplay from '@/components/form/AutocompleteDisplay.vue';
import MultiSelect from '@/components/form/MultiSelect.vue';
import UrlField from '@/components/form/UrlField.vue';
import KpTinyMCE from '@/components/tinymce.vue';
import LoadingOverlay from '@/components/LoadingOverlay.vue';
import TimeDisplay from '@/components/TimeDisplay.vue';
import { userInfo, sessionInfo, customer } from '@/helpers/globals';
import { i18nInit, loadLocaleStrings } from '@/i18n';
import dayjs from 'dayjs';
import dayjsPlugins from '@/helpers/dayjs-plugins';
import { storeCsrfToken } from '@/helpers/auth';
import api from '@/helpers/api';

dayjs.extend(dayjsPlugins);

Vue.config.productionTip = false;

/** --------------- Define globally available Vue components --------------------- */
Vue.component('KpIcon', KpIcon);
Vue.component('KpFileInput', KpFileInput);
Vue.component('IconBtn', IconBtn);
Vue.component('SToolbar', SToolbar);
Vue.component('LightToolbar', LightToolbar);
Vue.component('BaseList', BaseList);
Vue.component('BaseRemoteList', BaseRemoteList);
Vue.component('ConfirmDialog', ConfirmDialog);
Vue.component('PromptDialog', PromptDialog);
Vue.component('KpAlert', KpAlert);
Vue.component('KpTooltip', KpTooltip);

Vue.component('TooltipIcon', TooltipIcon);
Vue.component('ActionBtn', ActionBtn);
Vue.component('SecondaryBtn', SecondaryBtn);
Vue.component('PlainBtn', PlainBtn);
Vue.component('DateTextfield', DateTextfield);
Vue.component('TrueFalseIcon', TrueFalseIcon);
Vue.component('TimeTextfield', TimeTextfield);
Vue.component('LabelField', LabelField);
Vue.component('QueryField', QueryField);

Vue.component('LoadingOverlay', LoadingOverlay);
Vue.component('AutocompleteDisplay', AutocompleteDisplay);
Vue.component('MultiSelect', MultiSelect);
Vue.component('UrlField', UrlField);
Vue.component('TimeDisplay', TimeDisplay);

Vue.component('TinymceEditor', KpTinyMCE);
/** --------------- END Define globally available Vue components --------------------- */

// we start async, as we have to load some things first:
const locale = userInfo().locale || 'de';

// load locale strings async here:
loadLocaleStrings(locale).then((localeStrings) => {
    storeCsrfToken(sessionInfo().csrfToken || '');
    api.init({ baseURL: window.apiRoot });

    // init store with initial data:
    const storeInst = store.init({
        session: sessionInfo(),
        customer: customer(),
        appVersion: window.appVersion || '',
        loading: false,
        loadingCounter: 0,
        snackbarContent: '',
    });
    Vue.use(toast);
    const i18n = i18nInit(locale, localeStrings);
    if (userInfo().id > 0) {
        storeInst.commit('user/setUser', userInfo());
    }
    new Vue({
        router,
        store: storeInst,
        vuetify,
        toast,
        i18n,
        render: (h) => h(App),
    }).$mount('#app');
});
